import { HttpClient } from '../HttpClient';
/**
 * * Get statement breakdown
 **/

export const GetStatementBreakdown = async (id) => {
  try {
    const response = await HttpClient.get(
      `/api/instacash/statements/${id}/breakdown`
    );
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
